/**
 * The base domain for the API, loaded from environment variables.
 * This value is set in the .env file (e.g., REACT_APP_DOMAIN=http://127.0.0.1:8000/)
 */
export const domain = process.env.REACT_APP_DOMAIN;
